import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { eur } from "@/components/common";
import { useAuth } from "@/context/AuthContext";

// Mette in evidenza in home due prodotti del catalogo Extra (dati live dall'API,
// nessuna duplicazione): composizione in ciotola e vaso con piantine.
const MATCH = [(e) => e.name.toLowerCase().includes("ciotola"), (e) => e.name.toLowerCase().includes("piantine")];

export default function ExtraInEvidenza() {
  const [items, setItems] = useState(null);
  const { user } = useAuth();

  useEffect(() => {
    api.get("/extras?category=extra")
      .then((r) => setItems(MATCH.map((m) => r.data.find((e) => !e.quote_only && m(e))).filter(Boolean)))
      .catch(() => setItems([]));
  }, []);

  if (!items || items.length === 0) return null;

  return (
    <section data-testid="extra-home-section" className="max-w-6xl mx-auto px-4 sm:px-6 pb-14 sm:pb-20">
      <div className="text-center mb-10">
        <p className="eyebrow mb-2">Un pensiero in più</p>
        <h2 className="font-serif text-3xl sm:text-4xl text-navy">Fiori e piantine, consegnati da noi.</h2>
        <p className="text-sm text-body leading-relaxed mt-3 max-w-2xl mx-auto">
          Li portiamo durante un tuo intervento già programmato, senza costi di consegna,
          oppure con un'uscita dedicata: scegli tu.
        </p>
      </div>
      <div className="grid gap-5 sm:grid-cols-2 max-w-3xl mx-auto">
        {items.map((e) => (
          <div key={e.id} className="card-soft overflow-hidden flex flex-col" data-testid={`extra-home-card-${e.id}`}>
            <img src={e.image} alt={e.name} className="w-full aspect-[4/3] object-cover" loading="lazy" />
            <div className="p-6 flex flex-col flex-1">
              <div className="flex items-baseline justify-between gap-3 mb-1.5">
                <p className="font-semibold text-navy">{e.name}</p>
                <p className="font-serif text-xl text-navy whitespace-nowrap">{eur(e.price)}</p>
              </div>
              <p className="text-sm text-body leading-relaxed mb-5 flex-1">{e.description}</p>
              <Link
                to={user ? `/checkout?type=extra&extras=${e.id}` : "/accedi"}
                data-testid={`extra-home-cta-${e.id}`}
                className="btn-primary self-start"
              >
                Richiedilo <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        ))}
      </div>
      <p className="text-center text-xs text-muted-soft mt-6">
        Consegna gratuita se hai già un intervento programmato; in caso di uscita dedicata si applica
        il supplemento di consegna, una sola volta.{" "}
        <Link to="/extra" data-testid="extra-home-all" className="font-semibold text-[#4a7c59]">
          Vedi tutti gli Extra
        </Link>
      </p>
    </section>
  );
}
